<template>

 <div>
	 <v-dialog title="课程账户退费" v-model="hideShow" width="600px" persistent scrollable>
		<v-card class="fc-dialog-card">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-cash-refund</v-icon></span><div><h2>课程退费</h2><p>核对账户余额与实际退费金额</p></div><v-spacer /><v-btn icon aria-label="关闭课程退费" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-row dense>
					<v-col cols="12">
						<span class="fc-form-note">注:退费功能适用于学员退学时需要退费的场景,其他场景勿用。</span>
					</v-col>
				</v-row>
				<v-row dense v-if="account" class="">
					<v-col cols="6">
						<v-text-field label="学员姓名" v-model="account.studentName" disabled dense outlined color="#d9363e" aria-label="学员姓名"></v-text-field>
					</v-col>
					<v-col cols="6">
						<v-text-field label="课程名称" v-model="account.courseName" disabled dense outlined color="#d9363e" aria-label="课程名称"></v-text-field>
					</v-col>
					<v-col cols="6">
						<v-text-field label="课时余额" v-model="account.balanceHour" disabled dense outlined color="#d9363e" aria-label="课时余额"></v-text-field>
					</v-col>
					<v-col cols="6">
						<v-text-field label="金额余额" v-model="account.balanceFee" disabled dense outlined color="#d9363e" aria-label="金额余额"></v-text-field>
					</v-col>
					<v-col cols="12" class="">
						<v-text-field label="实际退费金额" v-model="refund.realRefundAmount" type="number" dense outlined color="#d9363e" aria-label="实际退费金额"></v-text-field>
					</v-col>
					<v-col cols="12" class="">
						<v-text-field label="备注" v-model="refund.memo" dense outlined color="#d9363e" aria-label="备注"></v-text-field>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="cancel" outlined color="#65758c">取消</v-btn>
				<v-btn @click="submitRefund" :disabled="refund.submitting" :loading="refund.submitting" depressed class="fc-confirm" color="#d9363e">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
 </div>

</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"course-account-refund",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			account:{
				type:Object,
				default:null
			}
		},
		watch:{
			show(newVal,oldVal){
			
				this.hideShow = newVal;
				if(this.hideShow){
					this.refund.realRefundAmount = "";
				}
			}
		},
		data(){
			return {
				shopId:"",
				hideShow:this.show,
				refund:{
					submitting:false,
					realRefundAmount:"" ,// 实际退费金额
					memo:""
				}
			}
		},
		mounted() {
			console.log("class-upgrade mounted");
			this.shopId = utils.getCurrentShopId();
		},
		methods:{
			cancel(){
				this.$emit("cancel","");
			},
			submitRefund(){
				if(!this.refund.realRefundAmount){
					this.$noty.error("请输入实际退费金额");
					return
				}
				this.refund.submitting = true;
				
				
				let postData = {
					accountId:this.account.id,
					realRefundFee:this.refund.realRefundAmount,
					memo:this.refund.memo
				}
				// api
				const that = this;
				let url = `/financial/course/account/refund`;
					
				this.axios.post(url, postData).catch(() => {
					that.refund.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							
							that.refund.submitting = false;
							that.$emit("success","");
							return;
						} else {
							that.refund.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.refund.submitting = false;
						that.$noty.error('网络请求失败');
					}
							
				});
			},
		}
	}
	
</script>

<style lang="scss" scoped src="../assets/styles/course-account-dialog.scss"></style>
